import { ICustomFieldFormConfiguration, ICustomFieldsDTO } from '../../../../../../../api/custom-fields.dao';


type ConfigValueType = string | number | boolean;
export class CustomFieldConfigurator {
    public static readonly defaultFormName = '';
    public static get defaultFieldConfiguration(): ICustomFieldFormConfiguration {
        return { formName: CustomFieldConfigurator.defaultFormName, order: 0, mandatory: false, visible: true };
    }

    public static get defaultTriageQuestionConfiguration(): ICustomFieldFormConfiguration {
        return { formName: CustomFieldConfigurator.defaultFormName, order: 0, mandatory: true, visible: true };
    }

    public static getFieldConfigIndexByFormName(field: ICustomFieldsDTO, formName: string): number {
        return field.configurations.findIndex(cnf => cnf.formName === formName);
    }

    public static getFieldDefaultConfigIndex(field: ICustomFieldsDTO): number {
        return CustomFieldConfigurator.getFieldConfigIndexByFormName(field, CustomFieldConfigurator.defaultFormName);
    }

    public static getFieldConfigByFormName(field: ICustomFieldsDTO, formName: string): ICustomFieldFormConfiguration {
        return field.configurations.find(cnf => cnf.formName === formName);
    }

    public static getFieldDefaultConfiguration(field: ICustomFieldsDTO): ICustomFieldFormConfiguration {
        return CustomFieldConfigurator.getFieldConfigByFormName(field, CustomFieldConfigurator.defaultFormName);
    }

    public static getFieldConfigurationValueByKey(field: ICustomFieldsDTO, key: keyof ICustomFieldFormConfiguration, formName: string): ConfigValueType {
        const config = CustomFieldConfigurator.getFieldConfigByFormName(field, formName);

        return config[key];
    }

    public static getFieldDefaultConfigurationValueByKey(field: ICustomFieldsDTO, key: keyof ICustomFieldFormConfiguration): ConfigValueType {
        return CustomFieldConfigurator.getFieldConfigurationValueByKey(field, key, CustomFieldConfigurator.defaultFormName);
    }

    public static setFieldConfigValueByKey(field: ICustomFieldsDTO, key: keyof ICustomFieldFormConfiguration, value: ConfigValueType, formName: string): void {
        const configIdx = CustomFieldConfigurator.getFieldConfigIndexByFormName(field, formName);
        // @ts-ignore
        field.configurations[configIdx][key] = value;
    }

    public static setFieldDefaultConfigValueByKey(field: ICustomFieldsDTO, key: keyof ICustomFieldFormConfiguration, value: ConfigValueType): void {
        const configIdx = CustomFieldConfigurator.getFieldDefaultConfigIndex(field);
        // @ts-ignore
        field.configurations[configIdx][key] = value;
    }

    public static setFieldAllConfigsValueByKey(field: ICustomFieldsDTO, key: keyof ICustomFieldFormConfiguration, value: ConfigValueType): void {
        // @ts-ignore
        field.configurations.forEach(config => config[key] = value);
    }

}
